import {
    DomainInitPayload,
    SxmTypeDevice,
} from '@sxm-de/dev-kits/web-sdk/types';

interface GetSubscriptionLinkingEligibilityForRadioIdFnPayload {
    subscriptionId: string;
    radioId: string;
}

export type GetSubscriptionLinkingEligibilityForRadioIdFn = (
    payload: GetSubscriptionLinkingEligibilityForRadioIdFnPayload,
) => Promise<{
    device: SxmTypeDevice | null;
    isEligible: boolean;
}>;

export function initGetSubscriptionLinkingEligibilityForRadioIdFn({
    dependencies,
}: DomainInitPayload): GetSubscriptionLinkingEligibilityForRadioIdFn {
    // const { microservicesSdk } = dependencies;
    return async ({
        subscriptionId,
        radioId,
    }: GetSubscriptionLinkingEligibilityForRadioIdFnPayload) => {
        /**
         * TODO: Temporarily return mocked data until microservice endpoint is online.
         */
        return {
            device: {
                id: '990005530920',
                isVirtualId: false,
                type: 'car',
                radioIdLastFour: '0920',
                nickname: '',
                vehicle: {
                    make: 'Ford',
                    model: 'F-150',
                    year: '2024',
                    vin: '1FTFW1CT8EFB42220',
                    yearMakeModel: '2024 Ford F-150',
                },
            },
            isEligible: true,
        };

        // const radioInfo = await getRadioInformationForRadioIdSms(
        //     { radioId },
        //     dependencies,
        // );
        //
        // if (!radioInfo) {
        //     throw new Error('DEVICE_NOT_FOUND');
        // }
        //
        // try {
        //     const { eligibleRadio } =
        //         await microservicesSdk.domains.account.eligibilityCheck({
        //             subscriptionId,
        //             radioId,
        //         });
        //
        //     return {
        //         device: mapSmsDeviceToDevice(eligibleRadio),
        //         isEligible: true,
        //     };
        // } catch (error: any) {
        //     if (error.errorCode === 'CS_INELIGIBLE_RADIO') {
        //         /**
        //          * TODO: Add analytics for ineligible radio
        //          */
        //
        //         /**
        //          * TODO: Temporary mapping of RadioInformationModel data to shape
        //          *       that mapSmsDeviceToDevice supports.
        //          */
        //         return {
        //             device: {
        //                 ...mapSmsDeviceToDevice({
        //                     radioId: radioInfo.deviceInformation.radioId ?? '',
        //                     last4DigitsOfRadioId: radioInfo.deviceInformation
        //                         .radioId
        //                         ? radioInfo.deviceInformation.radioId.slice(-4)
        //                         : '',
        //                     vehicleInfo: {
        //                         year: radioInfo.deviceInformation.vehicle?.year
        //                             ? radioInfo.deviceInformation.vehicle.year.toString()
        //                             : '',
        //                         make:
        //                             radioInfo.deviceInformation.vehicle?.make ??
        //                             '',
        //                         model:
        //                             radioInfo.deviceInformation.vehicle
        //                                 ?.model ?? '',
        //                         vin:
        //                             radioInfo.deviceInformation.vehicle?.vin ??
        //                             '',
        //                     },
        //                 }),
        //             },
        //             isEligible: false,
        //         };
        //     }
        //
        //     logErrorFromMicroservicesSdk(error, dependencies);
        //     throw new Error('SYSTEM');
        // }
    };
}
